import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import AppManager from "../../../managers/AppManager";
import RouteManager from "../../../managers/RouteManager";
import TimesheetService from "../TimesheetService";
import TimesheetUtils from "../TimesheetUtils";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import {
    removeLoader,
    showLoader,
    showToast,
    TOAST_TYPE
} from "deskera-ui-library";
import AddTask from "./AddTask";
import { fetchProject, selectProject } from "../../../Redux/Slices/ProjectSlice";
import Utility from "../../../utility/Utility";
import { useDispatch, useSelector } from "react-redux";
import { fetchTask, selectTask } from "../../../Redux/Slices/TaskSlice";
import { fetchBooksContact } from "../../../Redux/Slices/BooksContactSlice";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import { parseColumnConfig, parseVisibleColumnConfig } from "../../configs/config";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";

function Tasks(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const project = useSelector(selectProject);
    const task = useSelector(selectTask);
    const dispatch = useDispatch()
    const [showAddTask, setShowAddTask] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [reload, setReload] = useState(false);
    const [taskData, setTaskData] = useState({
        columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TASK), TABLES.PEOPLE_TASK)),
        rowData: [],
        filter: [],
        originalData: []
    });
    const [fetchingDependencies, setFetchingDependencies] = useState(true);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();
        
        fetchDependencies();
    }, []);
    useEffect(()=>{
        if(!Utility.isEmpty(task)) {
                if (task.data?.length > 0) {
                    const rowData = TimesheetUtils.getTasksRowData(task.data);
                    setTaskData({
                        ...taskData,
                        rowData: rowData,
                        originalData: rowData
                    });
                } else {
                    setTaskData({
                        ...taskData,
                        rowData: [],
                        originalData: []
                    });
                }
        }
    },[task])
    useEffect(() => {
        if(!Utility.isEmpty(project)) {
            let columns = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TASK), TABLES.PEOPLE_TASK));
            const ind = columns.findIndex(c=>c.columnCode === 'projectId')
            if(ind !== -1) {
                columns[ind].options = project.data?.map(e=>{ return {...e,label:e.name,value: e.id, id: e.id.toString()}}) || []
                setTaskData({
                    ...taskData,
                    columnData: columns
                });
            }
        }
    },[project,reload])
    useEffect(() => {
        if (!fetchingDependencies) {
            getTasks();
        }
    }, [fetchingDependencies]);

    const fetchDependencies = async() => {
        setFetchingDependencies(false);
        getTasks();
        await dispatch(fetchBooksContact());
        if(Utility.isEmpty(project)) {
            await dispatch(fetchProject());
        }
    }

    const getTasks = async() => {
        showLoader();
        await dispatch(fetchTask());
        removeLoader()
    }

    const onRowEdit = (data) => {
        if (data?.rowData) {
            TimesheetService.TASK = data.rowData.task;
            setShowAddTask(true);
        }
    }

    const onRowDelete = (data) => {
        if (data?.rowData) {
            showLoader("Deleting task... Please wait");
            let payload = {
                id:data.rowData.id
            }
            TimesheetService.deleteTask(payload).then(res=>{
                getTasks()
                removeLoader();
                showToast("Task deleted successfully.", TOAST_TYPE.SUCCESS);
            },error=>{
                removeLoader();
                const message = error && error.message ? error.message : t("SOMETHING_WENT_WRONG")
                showToast(message, TOAST_TYPE.FAILURE);
            })
        }
    }

    return (
        <Fragment>
            {showAddTask &&
                <AddTask
                    onClose={(refresh) => {
                        setShowAddTask(false);
                        if (refresh) {
                            getTasks();
                        }
                    }}
                />
            }
            <div>
                <DataGridHolderPayroll
                    tableName={TABLES.PEOPLE_TASK}
                    displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_TASK]}
                    allowBulkOperation={true}
                    allowColumnEdit={false}
                    allowColumnDelete={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    allowColumnAdd={false}
                    allowRowAdd={false}
                    allowColumnSort={false}
                    refresh={false}
                    allowDataExport={false}
                    allowRowEdit={PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.EDIT])}
                    showContextEdit={false}
                    contextMenu={true}
                    isMenuVisible={false}
                    showContextMenu={true}
                    isActionEnabled={true}
                    gridData={taskData}
                    currentPage={currentPage}
                    totalPageCount={totalPageCount}
                    onRowEdit={(data) => {
                        onRowEdit(data);
                    }}
                    onRowDelete={(data) => {
                        onRowDelete(data);
                    }}
                    onPaginationClick={(requestedPageNumber) => {
                        setCurrentPage(requestedPageNumber);
                    }}
                    addButtonConfig={[{
                        title: `+ ${"Task"}`,
                        className: "bg-app text-white ml-s",
                        onClick: () => {
                            setShowAddTask(true);
                        }
                    }]}
                    onColumnShift={(data)=> setReload(!reload)}
                    module={MODULE.TIMESHEET}
                />
            </div>
        </Fragment>
    );
}

export default Tasks;
